import { SliderMarquee } from './slider-marquee';

const sliderMarqueeOptions = {
	mobile: {
		slidesPerView: 1,
		breakpoints: {
			400: {
				slidesPerView: 2,
			},
			600: {
				slidesPerView: 3,
			},
		},
	}
};
document.querySelectorAll( '.p-taxonomies__header-partner, .b-hero-series__partner' ).forEach( ( scroll ) => {

	new SliderMarquee( scroll, sliderMarqueeOptions );

} );
